import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * The user's past Nerobotti conversations, newest first.
 *
 * REST rather than a frame on the assistant's socket, deliberately. That socket
 * carries one conversation's turns and the panel unmounts it when closed; a
 * conversation *list* is neither, and putting it there would mean the transport
 * lambda — which is written to hold no logic and make no scope decisions —
 * growing a read path. The server takes the caller from the signature, so
 * nothing here names a user.
 *
 * `cursor` is opaque: it comes from the previous page's response and is passed
 * back untouched.
 */
export const getNerobottiThreads = async ({ cursor } = {}) => {
  const query = new URLSearchParams();
  if (cursor) query.set('cursor', cursor);

  const apiPath = `nerobotti/threads?${query.toString()}`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};

export default getNerobottiThreads;
